import type { Operator } from "./index.js"

export const equals: Operator = {
  key: "equals",
  label: "equals",
  icon: "equals",
  value: "scalar",
  fn: (a, b) => a === b,
}

export const notEquals: Operator = {
  key: "notEquals",
  label: "does not equal",
  icon: "not-equal",
  value: "scalar",
// A negated operator must EXCLUDE a null/absent value, matching SQL's
// three-valued logic — `NULL != 'x'` is NULL, not true, so Postgres filters
// the row out. `fn` is the client-side preview of the very same filter
// (useFilter.ts:366), and it used to disagree: `null !== "x"` is true in JS,
// so the preview included rows the server then dropped.
//
// The direction of the fix is set by the data, not by intuition. The live
// "Heavybit Portfolio Companies" list filters `member_stage != "exited"`.
// 12,719 of 12,831 organizations have no member_stage at all, so a
// null-INCLUSIVE reading turns a 64-company portfolio list into the entire
// organization table. SQL's semantics are the ones every stored filter was
// authored against; the preview is what was wrong.
  fn: (a, b) => a != null && a !== b,
}

export const equalsCI: Operator = {
  key: "equalsCI",
  label: "equals (case-insensitive)",
  icon: "equals",
  value: "scalar",
  fn: (a, b) => String(a ?? "").toLowerCase() === String(b ?? "").toLowerCase(),
}

export const notEqualsCI: Operator = {
  key: "notEqualsCI",
  label: "does not equal (case-insensitive)",
  icon: "not-equal",
  value: "scalar",
  // Null-excluding, for the reason given on notEquals above.
  fn: (a, b) => a != null && String(a).toLowerCase() !== String(b ?? "").toLowerCase(),
}
